import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faLightbulb, faShieldAlt, faUserGear } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/intellectual.jpg';

function IntellectualPropertyScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Intellectual Property (IP) Services'>
          <Breadcrumb parent="Services" screen='Intellectual Property (IP) Services'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="Intellectual Property (IP) Services"
          description="Protect your innovations with PocketLPO’s Intellectual Property (IP) Services. From trademark registration to IP portfolio management, we ensure your intellectual assets are safeguarded."
          services={[
            "Trademark searches and registration.",
            "Patent drafting and filing support.",
            "IP portfolio management and litigation support."
          ]}
          benefits={[
            { title: "Comprehensive Protection", description: "Secure your intellectual assets across jurisdictions.", icon: faShieldAlt },
            { title: "Strategic Insights", description: "Manage your IP portfolio effectively.", icon: faLightbulb },
            { title: "Expert Guidance", description: "Leverage our experience in IP law.", icon: faUserGear }
          ]}
          image={image}
        />
    </>
  );
}

export default IntellectualPropertyScreen;
